import { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const PublicProfileByColor = () => {
  const { userId, color } = useParams();
  const [profileId, setProfileId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(`${API_BASE}/api/p/${userId}/${color}`);
        // Redirect to the actual profile page
        setProfileId(response.data.profile.profile_id);
      } catch (err) {
        console.error('Profile not found:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [userId, color]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="spinner" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Profile Not Found</h1>
          <p className="text-slate-500">The {color} profile for this user doesn't exist.</p>
        </div>
      </div>
    );
  }

  if (profileId) {
    return <Navigate to={`/p/${profileId}`} replace />;
  }

  return null;
};

export default PublicProfileByColor;
